type Version = { resolution: string; video: string };

export type SelectPolicy = {
  // thresholds in Mbps (H.264)
  min1080p: number; // choose 1080p if >= this
  min720p: number;  // else choose 720p if >= this, otherwise 480p/lowest
};

export const DEFAULT_POLICY: SelectPolicy = {
  min1080p: 8,   // good 1080p experiences typically need ~8–10 Mbps
  min720p: 4,    // 720p ok from ~4 Mbps
};

export function pickBestRendition(
  versions: Version[] = [],
  netMbps: number | null,
  policy: SelectPolicy = DEFAULT_POLICY
): Version | undefined {
  if (!versions.length) return undefined;
  // build lookup by resolution
  const byRes = Object.fromEntries(versions.map(v => [v.resolution.toLowerCase(), v]));
  if (netMbps == null) return byRes['1080p'] || byRes['720p'] || versions[0];

  if (netMbps >= policy.min1080p) return byRes['1080p'] || byRes['720p'] || versions[0];
  if (netMbps >= policy.min720p)  return byRes['720p']  || byRes['480p'] || versions[0];
  return byRes['480p'] || byRes['360p'] || byRes['720p'] || versions[0];
}
